// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3s1EX","alert":"SettungsInbox_alert__3gmqY"};